// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, setDoc, getDocs, collection, query, data, where } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCjTjR9PWc1Zf0nj4TrP-1MJT932cT_9Eo",
  authDomain: "joke-db-c60d8.firebaseapp.com",
  databaseURL: "https://joke-db-c60d8-default-rtdb.firebaseio.com",
  projectId: "joke-db-c60d8",
  storageBucket: "joke-db-c60d8.appspot.com",
  messagingSenderId: "175403930516",
  appId: "1:175403930516:web:59f674989c1901b5997581",
  measurementId: "G-6BG3SNRVQG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

const jokes = [];
var size, randNum, randJoke, newJoke;
var jokeIndex = 0;

const generated_joke = document.getElementById("generated-joke");

async function generateJoke() {
  const jokesRef = query(collection(db, "jokes"), where("joke", "!=", null));
  const jokeDocs = await getDocs(jokesRef);

  jokeDocs.forEach((doc) => {
    jokes.push(doc.data());
  });

  size = jokes.length;
  newJoke = jokes[jokeIndex].joke;

  console.log("Finding new joke...");
  console.log(newJoke);
  generated_joke.innerHTML = newJoke;

  if(jokeIndex < size) {
    jokeIndex += 1;
  } else {
    console.log("Starting over...");
    jokeIndex = 0;
  }
}

export { db, generateJoke }
